import React from 'react';

import { Delete } from '@mui/icons-material';
import { ListSubheader, IconButton, type ListSubheaderProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledListSubheader = styled(ListSubheader)`
    padding-right: 0.5rem;
    display: flex;
    background-color: white;
`;

const StyledListSubheaderText = styled(Typography)`
    word-break: break-all;
`;

const StyledIconButton = styled(IconButton)`
    width: 2rem;
    height: 2rem;
    align-self: center;
    margin-left: auto;
`;

export type PdfHeaderProps = ListSubheaderProps & {
    fileName: string;
    onDeleteClick?: (fileName: string) => void;
};

export const PdfHeader = (props: PdfHeaderProps) => {
    const { fileName, onDeleteClick, ...rest } = props;
    const { t } = useTranslation('whiteboard');

    return (
        <StyledListSubheader {...rest}>
            <StyledListSubheaderText>{fileName}</StyledListSubheaderText>

            {onDeleteClick && (
                <StyledIconButton
                    size="small"
                    onClick={() => onDeleteClick(fileName)}
                    aria-label={t('deletePdf', { fileName })}
                >
                    <Delete fontSize="small" />
                </StyledIconButton>
            )}
        </StyledListSubheader>
    );
};
